module.exports = __webpack_public_path__ + "static/img/14002001.a50242db.png";